module.exports = __webpack_public_path__ + "img/2.6_Indigenous-Advisory-Group_4_Deaves@2x.c5f2ca69adcdd9d3e2c0745380d0f74f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_Indigenous-Advisory-Group_4_Deaves@2x.png
// module id = 789
// module chunks = 0